import { Input, InputProps, InputRef } from "antd";
import { ChangeEvent, HTMLAttributes, ReactElement, useState } from "react";
import "./index.scss";

export interface InputComponentProps {
  defaultValue?: string;
  inputprops?: InputProps & React.RefAttributes<InputRef>;
  onChangeText?: (text: string) => void;
  rightIcon?: ReactElement;
  onClick?: () => void;
  containerProps?: HTMLAttributes<HTMLDivElement>;
  isGray?:boolean
}

const InputComponent = (props: InputComponentProps) => {
  const {
    defaultValue,
    inputprops,
    onChangeText,
    rightIcon,
    containerProps,
    onClick,isGray
  } = props;

  const [text, setText] = useState(defaultValue ?? "");

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
    onChangeText && onChangeText(e.target.value);
  };

  return (
    <div className={isGray ? "SearchInputPopupStyleGray" : "SearchInputPopupStyle"} {...containerProps}>
      <div className="wrap-input-search-popup" onClick={onClick}>
        <Input
          value={text}
          onChange={onChange}
          className="input-search"
          placeholder="placeholder..."
          {...inputprops}
        />
        <div className="wrap-icon-search">{rightIcon ? rightIcon : <></>}</div>
      </div>
    </div>
  );
};

export default InputComponent;
